import { Card, CardContent } from '@/components/ui';

/**
 * Page-level empty state shown when the active scope has zero SonarCloud-
 * onboarded repos. Replaces all inner slots; the caveat banner above it still
 * renders so the user has context for why the page is empty (and a path to
 * onboarding via the catalog).
 */
export function NoSonarOnboardedState() {
  return (
    <Card className="shadow-none" data-testid="code-quality-no-sonar-onboarded">
      <CardContent className="p-12 text-center">
        <p className="text-sm font-semibold text-foreground">No SonarCloud-onboarded repos in this scope</p>
        <p className="mt-2 text-xs text-muted-foreground">
          Code Quality data appears here once a repo in the active product/team scope is registered
          in SonarCloud and a sync has run.
        </p>
      </CardContent>
    </Card>
  );
}
